let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l0xyj")).then(() => parcelRequire('1tbmT'));